import React, { useState , useRef, useCallback,useEffect } from "react";
import ReactEcharts from "echarts-for-react";
import { LineChart } from "echarts/charts";
import {
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  VisualMapComponent,
} from "echarts/components";
import * as echarts from "echarts/core";
import { UniversalTransition } from "echarts/features";
import {CanvasRenderer} from "echarts/renderers";
import {useStore, useDispatch } from "react-redux";
import {
  deleteZoomChart, zoomChart
} from "../../axios/index";

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LineChart,
  CanvasRenderer,
  UniversalTransition,
  DataZoomComponent,
  LegendComponent,
  VisualMapComponent,
  ToolboxComponent,
]);

function Chart({
  metadata,
  axes,
  legendNames,
  data,
  onChartClick,
  showLegend = false,
  saveZoom = true,
}) {

  console.log("Chart.js Rendered") 
  const store = useStore();
  const dispatch = useDispatch();
  const chartRef = useRef(null);
  const savedZoom = store.getState().chartZoom || [];
  const [render, setRender ]= useState(false)

  const dataZoomConfig = savedZoom.length && savedZoom.length ==2
  ? savedZoom.map((z) => ({
      id:         z.id,
      type:       "inside",
      xAxisIndex: z.xAxisIndex,
      yAxisIndex: z.yAxisIndex,
      filterMode: "none",
      /* start:      z.start,
      end:        z.end, */
      startValue: z.startValue,
      endValue:   z.endValue,
      zoomOnMouseWheel: true, moveOnMouseWheel: false 
    }))
  : [
      { id: "zoomX", type: "inside", xAxisIndex: [0], filterMode: "none",zoomOnMouseWheel: true, moveOnMouseWheel: false  },
      { id: "zoomY", type: "inside", yAxisIndex: [0], filterMode: "none",zoomOnMouseWheel: true ,moveOnMouseWheel: false },
    ];

  const handleDataZoom = useCallback((evt) => {  
    const chart = chartRef.current?.getEchartsInstance();
    if (!chart) return; 
    const dzOptions = chart.getOption().dataZoom;
    const zoomAxisData=[] 

    evt?.batch?.forEach((b) => {
      // match on the internal dataZoomId
      const isXAxis = b.dataZoomId.includes("xAxis");
      const dzOpt = dzOptions.find(dz =>
      isXAxis
        ? dz.xAxisIndex?.[0] === 0    
        : dz.yAxisIndex?.[0] === 0 
    );
      if (!dzOpt) return; 
      const payload = {
        id:         dzOpt.id,
        xAxisIndex: dzOpt.xAxisIndex,
        yAxisIndex: dzOpt.yAxisIndex,
        start:      dzOpt.start,
        end:        dzOpt.end,
        startValue: b.startValue,
        endValue:   b.endValue,
      };
      if (saveZoom) {
        zoomAxisData.push(payload)
      }
    });
    if (saveZoom && zoomAxisData && zoomAxisData.length==2) {  
      dispatch( zoomChart(zoomAxisData) );   
    }
    /* chart.dispatchAction({
      type: 'takeGlobalCursor',
      key: 'dataZoomSelect',
      dataZoomSelectActive: true
    }); */
  },[dispatch]);

  useEffect(() => { 
    const chart = chartRef.current?.getEchartsInstance();
    if (!chart || !savedZoom?.length) return;

    console.log("useEffect() applied ", savedZoom) 

    dataZoomConfig.forEach(z => {
      chart.dispatchAction(z);
    });
  }, [render]);

  const onRestore =  (() => {
    dispatch(deleteZoomChart());
    setRender(!render)
   // chartRef.current.getEchartsInstance().dispatchAction({ type: 'restore' });
  } );

 
  const onEvents = {
    click:    onChartClick,
    datazoom: handleDataZoom,
    restore: onRestore, 
  };

  const nameDetail = [
    metadata?.materialID,
    metadata?.name,
    metadata?.testMethod,
  ].filter(Boolean).join("_");

 
  return (
    <ReactEcharts
      ref={chartRef}                
      echarts={echarts}
      opts={{ renderer: "canvas" }}
      onEvents={onEvents}
      lazyUpdate
      style={{ height: "100%", width: "auto" }}
      option={{
        tooltip: {
          formatter: function (params) {
            var data = params.data || [0, 0];
            return `<b style='color: ${params.color}'>${params.seriesName}</b><br>` + data[0] + ", " + data[1];
          },
        },
        toolbox: {
          show: true,
          top: 8,
          right: 20,
          feature: {
            dataZoom: {
              // explicit: both axes get toggled
             /*  xAxisIndex: [0],
              yAxisIndex: [0],
              filterMode: 'none' */
            },
            restore: {},
            saveAsImage: {
              show: true,
              title: 'Download as PNG',
              type: 'png',                
              name:nameDetail,            
              pixelRatio: 2,              
              backgroundColor: '#ffffff',  
              excludeComponents: ['toolbox']
            }
          }
        },
        legend: {
          show: showLegend,
          data: legendNames,
          top: 8,
          selectedMode: false,
        },
        grid: {
          containLabel: true,
          left: 28,
          right: 24,
          top: 48,
          bottom: 36,
        },
        xAxis: {
          name: axes === "STRAIN_STRESS" ? "Strain" : "Crosshead (cm)",
          type: "value",
          minorTick: {
            show: true,
          },
          minorSplitLine: {
            show: true,
          },
          nameLocation: "middle",
          nameGap: 36,
        },
        yAxis: {
          name: axes === "STRAIN_STRESS" ? "Stress (kPa)" : "Load (gf)",
          type: "value",
          minorTick: {
            show: true,
          },
          minorSplitLine: {
            show: true,
          },
          nameLocation: "middle",
          nameGap: 36,
        },
         
        dataZoom: dataZoomConfig,

        series: data,
        animation: false,
      }}
    />
  );
}

export default Chart;
